import { learnApiClient } from '../../clients/learnApiClient';

export const getAuthToken = async (): Promise<string> => {
  const response = await learnApiClient.get(`continu-insights/token`);
  return response.data.token;
};
